import { observer } from 'mobx-react';
import { useQuery } from '@tanstack/react-query';
import { TAB_QUERY_CACHE_TIME, RELATED_DATA_POLL_REFETCH_INTERVAL } from './constants';
import {
    CadNextRelatedDataVehicleQuery,
    CadNextRelatedDataLocationQuery,
    RelatedDataPersonQuery,
} from '@mark43/cad-api';
import { useRelatedData } from './use-related-data';

export const RelatedDataPollExistingEvent = observer(
    (props: { eventId: number; eventLastUpdatedDateUtc?: string }) => {
        const { fetchRelatedData, isPollEnabled } = useRelatedData();
        const { eventId, eventLastUpdatedDateUtc } = props;

        useQuery(
            ['related-data-tab-by-event-id', eventId, eventLastUpdatedDateUtc] as const,
            async () => {
                const relatedDataView = await fetchRelatedData({
                    isNewEvent: false,
                    retries: 1,
                });
                return relatedDataView;
            },
            {
                cacheTime: TAB_QUERY_CACHE_TIME,
                refetchInterval: RELATED_DATA_POLL_REFETCH_INTERVAL,
                enabled: isPollEnabled,
            }
        );

        return null;
    }
);

export const RelatedDataPollNewEvent = observer(
    (props: {
        phoneNumbers: string[];
        vehicleQueries: CadNextRelatedDataVehicleQuery[];
        relatedDataLocationQuery?: CadNextRelatedDataLocationQuery;
        personQueries: RelatedDataPersonQuery[];
    }) => {
        const { fetchRelatedData, isPollEnabled } = useRelatedData();
        const { phoneNumbers, vehicleQueries, relatedDataLocationQuery, personQueries } = props;

        useQuery(
            [
                'related-data-tab',
                phoneNumbers,
                vehicleQueries,
                relatedDataLocationQuery,
                personQueries,
            ] as const,
            async () => {
                const relatedDataView = await fetchRelatedData({
                    isNewEvent: true,
                    retries: 1,
                    newEventFields: {
                        phoneNumbers,
                        vehicleQueries,
                        relatedDataLocationQuery,
                        personQueries,
                    },
                });
                return relatedDataView;
            },
            {
                cacheTime: TAB_QUERY_CACHE_TIME,
                refetchInterval: RELATED_DATA_POLL_REFETCH_INTERVAL,
                enabled: isPollEnabled,
            }
        );

        return null;
    }
);
